import { render, staticRenderFns } from "./dept-ureg-view.vue?vue&type=template&id=25ff6bd9&scoped=true"
import script from "./dept-ureg-view.vue?vue&type=script&lang=js"
export * from "./dept-ureg-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ff6bd9",
  null
  
)

export default component.exports